import styled from "@emotion/styled";
import { colors } from "src/theme";
import { Text } from "../typography";

const CardStyle = styled.div((props: { background?: string }) => ({
  backgroundColor: props.background || colors.background7,
  width: '100%',
  borderRadius: '8px',
  padding: 0
}));

const ContentStyle = styled.div((props: { padding?: string | number }) => ({
  padding: props.padding || '16px 32px',
  paddingBottom: 32
}));

const TitleStyle = styled(Text)({
  backgroundColor: colors.primary1,
  borderRadius: '8px 8px 0 0',
  color: colors.white,
  padding: '8px 16px',
});

interface CardWithTitleProps {
  title: string;
  children: React.ReactNode;
  padding?: string | number;
  background?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const CardWithTitle = ({ title, children, padding, background, className, style }: CardWithTitleProps) => (
  <CardStyle background={background} style={style} className={className}>
    <TitleStyle as="h2" type="sMedium" bold>{title}</TitleStyle>
    <ContentStyle padding={padding}>
      {children}
    </ContentStyle>
  </CardStyle>
);